import React, { useContext } from "react";
import { IngredientBase } from "./IngredientBase";
import { IngredientBaseLegacy } from "./IngredientBaseLegacy";
import IngredientRegisterModalView from "./ingredientRegister/IngredientRegisterModalView";
import { DrawingContext } from "../../../../components/drawing-tool/DrawingTool";
import { ENABLE_MAPPING_INGREDIENT_UI_REDESIGN } from "../../../../config/constants";
import { MappingSourceType } from "../../../../config/enums/MappingSourceType.enum";

const IngredientDetailsView = ({ modalData }:any) => {
      const {
        mappingSourceType,
      } = useContext(DrawingContext);
    const ingredientRegister = mappingSourceType === MappingSourceType.ingredient && !modalData.data.reference
    const ingredientContentView = () =>{
        if (ingredientRegister){
            return <IngredientRegisterModalView />
        }
        return ENABLE_MAPPING_INGREDIENT_UI_REDESIGN ? <IngredientBase/> : <IngredientBaseLegacy/>
    }

    return (
        <>{ingredientContentView()}</>     
    )
}

export default IngredientDetailsView